import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Divider,
  Form,
  Radio,
  Checkbox,
  Button,
  Spin,
  message,
  Select,
} from "../../../components/common/utils/antd-imports/AntdImports";
import "./LeadGenerationForm.css";
import "../../../styles/GlobalStyle.css";
import FloatingInput from "../../../components/common/float-input/FloatInput";
import FloatingSelect from "../../../components/common/floating-select/floatingSelect";
import FloatingTextArea from "../../../components/common/floating-textarea/FloatingTextArea";
import { userQueryPost } from "../../../store/thunks/common-thunks/commonThunk";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactComponent as UsFlag } from "../../../assests/flag-for-united-states.svg";
import { ReactComponent as UkFlag } from "../../../assests/flag-for-united-kingdom.svg";
import { ReactComponent as CaFlag } from "../../../assests/flag-canada.svg";
import { ReactComponent as AuFlag } from "../../../assests/flag-for-australia.svg";
import { ReactComponent as InFlag } from "../../../assests/greatest-flag-india.svg";
import { ReactComponent as DeFlag } from "../../../assests/flag-for-germany.svg";
import { ReactComponent as FrFlag } from "../../../assests/flag-france.svg";
import { ReactComponent as SgFlag } from "../../../assests/flag-for-singapore.svg";
import { ReactComponent as UAEFlag } from "../../../assests/flag-united-arab-emirates.svg";

import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useMediaQuery } from "react-responsive";
const Text = Typography;
const LeadGenerationForm = () => {
  const [form] = Form.useForm();
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const dispatch = useDispatch();
  const { isLoading, status } = useSelector((state) => state.billboardEnquiry);
  const [country, setCountry] = useState("US");
  const isMobile = useMediaQuery({ maxWidth: 425 });
  const isTablet = useMediaQuery({ minWidth: 769, maxWidth: 1024 });
  const navigate = useNavigate();
  const userType = Form.useWatch("user_type", form);
  const values = Form.useWatch([], form);
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };

  const ABOUT_USER_OPTIONS = [
    { id: "brand-owner", name: "Brand owner / Advertiser" },
    { id: "marketing-manager", name: "Marketing manager" },
    { id: "media-planner", name: "Media planner or buyer" },
    { id: "advertising-agency", name: "Advertising agency" },
    { id: "campaign-strategist", name: "Campaign strategist" },
    { id: "billboard-owner", name: "Billboard owner" },
    { id: "media-owner", name: "Media owner or publisher" },
    { id: "ooh-network-operator", name: "OOH network operator" },
    { id: "location-partner", name: "Location or asset partner" },
    { id: "platform-partner", name: "Platform or technology partner" },
    { id: "consultant", name: "Consultant" },
    { id: "reseller-aggregator", name: "Reseller or aggregator" },
  ];

  const LOOKING_FOR_OPTIONS = [
    {
      id: "run-an-ooh",
      name: "Run an OOH advertising campaign",
    },
    {
      id: "list-or-manage",
      name: "List or manage OOH inventory",
    },
    {
      id: "request-a-demo",
      name: "Request a product demo",
    },
    {
      id: "pricing",
      name: "Pricing or commercial discussion",
    },
    {
      id: "partnership-enquiry",
      name: "Partnership enquiry",
    },
    {
      id: "general-enquiry",
      name: "General enquiry",
    },
  ];
  const MARKETING_SOURCE_OPTIONS = [
    { id: "linkedin", name: "LinkedIn" },
    { id: "instagram", name: "Instagram" },
    { id: "google-search", name: "Google Search" },
    { id: "referal", name: "Referral" },
    { id: "industry-article", name: "Industry article or blog" },
  ];

  const COUNTRY_LIST = [
    {
      value: "US",
      label: "United States",
      code: "+1",
      min: 10,
      max: 10,
      Flag: UsFlag,
    },
    {
      value: "UK",
      label: "United Kingdom",
      code: "+44",
      min: 9,
      max: 10,
      Flag: UkFlag,
    },
    {
      value: "CA",
      label: "Canada",
      code: "+1",
      min: 10,
      max: 10,
      Flag: CaFlag,
    },
    {
      value: "AU",
      label: "Australia",
      code: "+61",
      min: 9,
      max: 9,
      Flag: AuFlag,
    },
    {
      value: "IN",
      label: "India",
      code: "+91",
      min: 10,
      max: 10,
      Flag: InFlag,
    },
    {
      value: "DE",
      label: "Germany",
      code: "+49",
      min: 10,
      max: 11,
      Flag: DeFlag,
    },
    { value: "FR", label: "France", code: "+33", min: 9, max: 9, Flag: FrFlag },
    {
      value: "SG",
      label: "Singapore",
      code: "+65",
      min: 8,
      max: 8,
      Flag: SgFlag,
    },
    {
      value: "AE",
      label: "United Arab Emirates",
      code: "+971",
      min: 9,
      max: 9,
      Flag: UAEFlag,
    },
  ].sort((a, b) => a.label.localeCompare(b.label));

  const LIB_PHONE_COUNTRY_MAP = {
    UK: "GB", // libphonenumber uses GB, not UK for the tracking the number
  };

  // Book an appointment with Sulivan url
  const bookSlotLink =
    "https://outlook.office.com/book/AdvertisingMarketplace@NETORG6600160.onmicrosoft.com/?ismsaljsauthenabled";

  const isFormValid = React.useMemo(() => {
    if (!values) return false;

    // Any validation errors?
    const hasErrors = form
      .getFieldsError()
      .some(({ errors }) => errors.length > 0);

    if (hasErrors) return false;

    // Required fields
    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "phone_number",
      "about_user",
      "looking_for",
      "marketing_source",
      "consent",
    ];

    if (form.getFieldValue("user_type") === "company") {
      requiredFields.push("company_name");
    }

    const requiredFilled = requiredFields.every((field) => {
      const value = form.getFieldValue(field);

      // Consent checkbox
      if (field === "consent") {
        return value === true;
      }

      // 📞 PHONE NUMBER RULES (ALL COUNTRIES)
      if (field === "phone_number") {
        const digits = (value || "").replace(/\D/g, "");
        const countryRule = COUNTRY_LIST.find((c) => c.value === country);

        if (!countryRule) return false;

        const { min, max } = countryRule;

        // ❌ Must meet min length
        if (digits.length < min) return false;

        // ❌ Must not exceed max length
        if (digits.length > max) return false;

        // 🇺🇸 🇨🇦 US / CA (NANP)
        if (
          (country === "US" || country === "CA") &&
          !/^[2-9]\d{9}$/.test(digits)
        ) {
          return false;
        }

        // 🇮🇳 India (starts with 6–9)
        if (country === "IN" && !/^[6-9]\d{9}$/.test(digits)) {
          return false;
        }

        // 🇬🇧 UK (mobile starts with 7)
        if (country === "UK" && !/^7\d{9}$/.test(digits)) {
          return false;
        }

        // 🇦🇺 Australia (mobile starts with 4)
        if (country === "AU" && !/^4\d{8}$/.test(digits)) {
          return false;
        }

        // 🇫🇷 France (starts with 6 or 7)
        if (country === "FR" && !/^[67]\d{8}$/.test(digits)) {
          return false;
        }

        // 🇸🇬 Singapore (starts with 8 or 9)
        if (country === "SG" && !/^[89]\d{7}$/.test(digits)) {
          return false;
        }

        // 🇦🇪 UAE (starts with 5)
        if (country === "AE" && !/^5\d{8}$/.test(digits)) {
          return false;
        }

        // 🇩🇪 Germany (mobile starts with 1)
        if (country === "DE" && !/^1\d{9,10}$/.test(digits)) {
          return false;
        }
        const libCountry = LIB_PHONE_COUNTRY_MAP[country] || country;
        const phoneNumber = parsePhoneNumberFromString(digits, libCountry);
        if (!phoneNumber || !phoneNumber.isValid()) {
          return false;
        }
        return true;
      }

      // Default rule
      return Boolean(value);
    });

    return requiredFilled;
  }, [values, form, country]);

  // handling the user information
  const handleSubmit = (values) => {
    const utmSource = localStorage.getItem("utm_source");
    const payload = {
      name: `${values?.first_name || ""} ${values?.last_name || ""}`.trim(),
      email: values?.email || "",
      contactno: values?.phone_number || "",
      message: values?.message || "",
      business_type: values?.user_type === "company" ? "Company" : "Individual",
      location: values?.location || "",
      about_user: values?.about_user || "",
      looking_for: values?.looking_for || "",
      marketing_source: values?.marketing_source || "",
      linkedin_url: values?.linkedin || "",
      ...(values?.user_type === "company" &&
        values?.company_name && {
          companyName: values.company_name || "",
        }),
      ...(utmSource && {
        utm_source: utmSource,
      }),
      enquiry_type: "lead_gen_form",
    };
    if (!payload) return;
    dispatch(userQueryPost(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(res?.payload.message);
        navigate("/get-in-touch/success");
        form.resetFields();
      } else {
        message.error(res?.payload.message);
      }
    });
  };

  const handleUserTypeChange = (e) => {
    const value = e.target.value;
    form.setFieldsValue({ user_type: value });
    form.resetFields([
      "email",
      "company_name",
      "company_email",
      "phone_number",
    ]);
  };
  // phoneValidator.js (or keep above component)

  const phoneNumberValidator =
    ({ country, COUNTRY_LIST, LIB_PHONE_COUNTRY_MAP }) =>
    (_, value) => {
      if (!value || !country) {
        return Promise.resolve();
      }

      const digits = value.replace(/\D/g, "");
      const countryConfig = COUNTRY_LIST.find((c) => c.value === country);

      if (!countryConfig) {
        return Promise.resolve();
      }

      const { min, max } = countryConfig;

      // Do not validate while user is typing
      if (digits.length < min) {
        return Promise.resolve();
      }

      // Too long
      if (digits.length > max) {
        return Promise.reject(
          new Error(`Phone number cannot exceed ${max} digits`),
        );
      }

      // 🇺🇸 🇨🇦 US / CA (NANP)
      if (
        (country === "US" || country === "CA") &&
        !/^[2-9]\d{9}$/.test(digits)
      ) {
        return Promise.reject(new Error("Invalid US/Canada phone number"));
      }

      // 🇮🇳 India (starts with 6–9)
      if (country === "IN" && !/^[6-9]\d{9}$/.test(digits)) {
        return Promise.reject(
          new Error("Indian mobile numbers must start with 6–9"),
        );
      }

      // 🇬🇧 United Kingdom (mobile starts with 7)
      if (country === "UK" && !/^7\d{9}$/.test(digits)) {
        return Promise.reject(new Error("UK mobile numbers must start with 7"));
      }

      // 🇦🇺 Australia (mobile starts with 4)
      if (country === "AU" && !/^4\d{8}$/.test(digits)) {
        return Promise.reject(
          new Error("Australian mobile numbers must start with 4"),
        );
      }

      // 🇫🇷 France (starts with 6 or 7)
      if (country === "FR" && !/^[67]\d{8}$/.test(digits)) {
        return Promise.reject(
          new Error("French mobile numbers must start with 6 or 7"),
        );
      }

      // 🇸🇬 Singapore (starts with 8 or 9)
      if (country === "SG" && !/^[89]\d{7}$/.test(digits)) {
        return Promise.reject(
          new Error("Singapore numbers must start with 8 or 9"),
        );
      }

      // 🇦🇪 UAE (starts with 5)
      if (country === "AE" && !/^5\d{8}$/.test(digits)) {
        return Promise.reject(
          new Error("UAE mobile numbers must start with 5"),
        );
      }

      // 🇩🇪 Germany (mobile starts with 1)
      if (country === "DE" && !/^1\d{9,10}$/.test(digits)) {
        return Promise.reject(new Error("Invalid German mobile number"));
      }

      // FINAL CHECK — libphonenumber-js
      const libCountry = LIB_PHONE_COUNTRY_MAP[country] || country;

      const phoneNumber = parsePhoneNumberFromString(digits, libCountry);
      if (!phoneNumber || !phoneNumber.isValid()) {
        return Promise.reject(
          new Error("Invalid phone number for selected country"),
        );
      }

      return Promise.resolve();
    };

  return (
    <div className="lead-genearation-container">
      <>
        <Row className="lead-gen-main-component-row">
          <Col className="connect-image-and-text-container">
            <Row className="search-build-header-row">
              <Row className="search-header-text-row">
                <Text className="connect-with-header">
                  Search. {<span style={{ color: "#d2042d" }}>Build</span>} .
                </Text>
                <Text className="connect-with-header">Purchase</Text>
              </Row>
              <Row className="whether-text-row">
                <Text className="plan-build-sub-text">
                  Plan, build and purchase your next{" "}
                  {<span className="add-campaign-span-text">ad campaign</span>}{" "}
                  with AdvertisingMarketplace.com
                </Text>
              </Row>
            </Row>
          </Col>
          <Col className="get-in-touch-col">
            <Card className="form-generation-card">
              <Row className="get-in-touch-row-lead">
                <Text className=" common-main-header-text  ">Get in touch</Text>
                <Text className="this-is-information-text">
                  We're excited to hear from you! Our dedicated team is ready to
                  answer any questions or provide expert support. Thanks for
                  reaching out!
                </Text>
              </Row>
              <Divider style={{ marginTop: "10px" }} />
              <Form
                form={form}
                initialValues={{
                  user_type: "individual",
                }}
                onFinish={handleSubmit}
              >
                <Row className="common-styling-row">
                  <Col className="common-styling-col">
                    <Form.Item
                      name="first_name"
                      rules={[
                        {
                          required: true,
                          message: "Please input your first name",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`First name `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      />
                    </Form.Item>
                  </Col>
                  <Col className="common-styling-col-right">
                    <Form.Item
                      name="last_name"
                      rules={[
                        {
                          required: true,
                          message: "Please input your last name",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {`Last name `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  name="user_type"
                  rules={[
                    {
                      required: true,
                      message: "Please select user type",
                    },
                  ]}
                >
                  <Radio.Group onChange={handleUserTypeChange}>
                    <Radio
                      value="individual"
                      className="lead-radio-button-text"
                    >
                      Individual
                    </Radio>
                    <Radio value="company" className="lead-radio-button-text">
                      Company
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Row className="common-styling-row">
                  <Col className="common-styling-col">
                    <Form.Item
                      name={userType === "company" ? "company_name" : "email"}
                      rules={[
                        {
                          required: true,
                          ...(userType !== "company" && { type: "email" }),
                          message: `Please input your ${
                            userType === "company" ? "company name" : "email"
                          }`,
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={
                          <>
                            {` ${userType === "company" ? "Company name" : "Email"} `}
                            {star}
                          </>
                        }
                        customStyles={floatingInputStyles}
                      />
                    </Form.Item>
                  </Col>

                  {userType === "company" && (
                    <Col className="common-styling-col-right">
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "Please input your company email",
                          },
                        ]}
                        style={{ width: "100%" }}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={<>Company email {star}</>}
                          customStyles={floatingInputStyles}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <Row className="common-styling-row">
                  <Col className="common-styling-col">
                    <Form.Item
                      name="location"
                      rules={[
                        {
                          message: "Please input your Location",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingInput
                        className="billboard-input-feild"
                        label={<>{`Location `}</>}
                        customStyles={floatingInputStyles}
                      />
                    </Form.Item>
                  </Col>

                  <Col className="common-styling-col-right combination-of-mobile">
                    <Select
                      className="billboard-select-feild country-select"
                      bordered={false}
                      showSearch
                      value={country}
                      onChange={(val) => {
                        setCountry(val);
                        form.setFieldsValue({ phone_number: undefined });
                        form.validateFields(["phone_number"]);
                      }}
                      dropdownClassName="country-select-dropdown"
                      optionFilterProp="searchLabel"
                      labelRender={(selected) => {
                        const c = COUNTRY_LIST.find(
                          (item) => item?.value === selected?.value,
                        );

                        if (!c) return selected?.value;
                        return (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <c.Flag />
                            <span>
                              {c?.value} ({c?.code})
                            </span>
                          </div>
                        );
                      }}
                      options={COUNTRY_LIST.map((c) => ({
                        value: c.value, // US
                        searchLabel: c.label, // United States (for search)

                        /* Dropdown option UI */
                        label: (
                          <div className="country-option-row">
                            <div className="country-option-left">
                              <c.Flag />
                              <span className="country-name">{c.label}</span>
                            </div>
                            <span className="country-code">{c.code}</span>
                          </div>
                        ),
                      }))}
                    />
                    {!isTablet && (
                      <Form.Item
                        name="phone_number"
                        validateTrigger={["onChange", "onBlur"]}
                        rules={[
                          {
                            required: true,
                            message: "Please input your phone number",
                          },
                          {
                            validator: phoneNumberValidator({
                              country,
                              COUNTRY_LIST,
                              LIB_PHONE_COUNTRY_MAP,
                            }),
                          },
                        ]}
                        style={{ width: isMobile ? "100%" : "50%" }}
                      >
                        <FloatingInput
                          className="billboard-input-feild "
                          label={
                            <>
                              {`Phone number `}
                              {star}
                            </>
                          }
                          maxLength={
                            COUNTRY_LIST.find((c) => c.value === country)?.max
                          }
                          onKeyPress={(e) => {
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          customStyles={{
                            ...floatingInputStyles,
                          }}
                        />
                      </Form.Item>
                    )}
                  </Col>
                </Row>
                {isTablet && (
                  <Row
                    gutter={[16, 16]}
                    className="coustomer-title-row common-styling-row"
                  >
                    <Col className="common-styling-col">
                      <Form.Item
                        name="phone_number"
                        validateTrigger={["onChange", "onBlur"]}
                        rules={[
                          {
                            required: true,
                            message: "Please input your phone number",
                          },
                          {
                            validator: phoneNumberValidator({
                              country,
                              COUNTRY_LIST,
                              LIB_PHONE_COUNTRY_MAP,
                            }),
                          },
                        ]}
                        style={{ width: isTablet ? "100%" : "50%" }}
                      >
                        <FloatingInput
                          className="billboard-input-feild "
                          label={
                            <>
                              {`Phone number `}
                              {star}
                            </>
                          }
                          maxLength={
                            COUNTRY_LIST.find((c) => c.value === country)?.max
                          }
                          onKeyPress={(e) => {
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          customStyles={{
                            ...floatingInputStyles,
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                <Row
                  gutter={[16, 16]}
                  className="coustomer-title-row common-styling-row"
                >
                  <Col className="common-styling-col">
                    <Form.Item
                      name="about_user"
                      rules={[
                        {
                          required: true,
                          message: "Please select your option",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        border={false}
                        label={
                          <>
                            {`Describe who you are  `} {star}
                          </>
                        }
                        options={ABOUT_USER_OPTIONS}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                  <Col className="common-styling-col-right">
                    <Form.Item
                      name="looking_for"
                      rules={[
                        {
                          required: true,
                          message: "Please select your option",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        border={false}
                        label={
                          <>
                            {`What you are looking for `} {star}
                          </>
                        }
                        options={LOOKING_FOR_OPTIONS}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[16, 16]}
                  className="coustomer-title-row common-styling-row"
                >
                  <Col className="common-styling-col">
                    <Form.Item
                      name="marketing_source"
                      rules={[
                        {
                          required: true,
                          message: "Please select your option",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingSelect
                        className="billboard-select-feild"
                        border={false}
                        label={
                          <>
                            {`How did you hear about us? `} {star}
                          </>
                        }
                        options={MARKETING_SOURCE_OPTIONS}
                        customStyles={floatingSelectStyles}
                      />
                    </Form.Item>
                  </Col>
                  <Col className="common-styling-col-right">
                    <Form.Item
                      name="linkedin"
                      rules={[
                        {
                          type: "url",
                          message: "Please enter a valid URL (https://...)",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <FloatingInput
                        className="billboard-input-feild "
                        label={<>{`LinkedIn URL `}</>}
                        customStyles={floatingInputStyles}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} className="coustomer-title-row">
                  <Form.Item
                    name="message"
                    rules={[]} // 👈 makes it explicit
                    validateTrigger="onChange"
                    style={{ width: "100%" }}
                    className="sample"
                  >
                    <FloatingTextArea
                      customStyles={textAreaFloatingInputStyles}
                      label={
                        <>
                          {`Tell us briefly about your goals, location, or questions `}
                        </>
                      }
                      showCount
                      maxLength={600}
                      className="billboard-input-feild billboard-text-area lead-textt-area "
                    />
                  </Form.Item>
                </Row>
                <Row className="this-is-information-text-row">
                  <Text className="this-is-information-text">
                    AdvertisingMarketplace.com respects your privacy and will
                    use your personal information only to manage your account
                    and deliver requested products/services. We'd like to
                    occasionally contact you about our offerings and relevant
                    content.
                  </Text>
                </Row>
                <Row className="check-box-lead-row">
                  <Col className="check-box-lead-col">
                    <Form.Item
                      name="consent"
                      valuePropName="checked"
                      rules={[
                        {
                          validator: (_, value) =>
                            value
                              ? Promise.resolve()
                              : Promise
                                  .reject
                                  // new Error("You must accept the consent"),
                                  (),
                        },
                      ]}
                      className="check-box-form-item"
                    >
                      <Checkbox
                        onChange={() => {
                          console.log(isFormValid);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col style={{ width: "90%" }}>
                    <Text className="this-is-information-text">
                      I agree to receive other communications from
                      advertisingmarketplace.com. *
                    </Text>
                  </Col>
                </Row>
                <Row className="this-is-information-text-row">
                  <Text className="this-is-information-text">
                    You can unsubscribe anytime. By submitting, you consent to
                    us storing and processing your information for the requested
                    content.
                  </Text>
                </Row>
                <Row className="book-an-appoint-btn-row">
                  <Button
                    id="get_in_touch_submit"
                    type="primary"
                    htmlType="submit"
                    className={`advertise-form-submit-button billboard-button-2 ${!isFormValid ? "disabled-opacity" : ""}`}
                    disabled={!isFormValid}
                  >
                    Submit
                  </Button>
                  <a
                    className="book-an-oppointment"
                    target="_blank"
                    href={bookSlotLink}
                    id="book_an_appointment"
                  >
                    Book an appointment
                  </a>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};
export default LeadGenerationForm;
